import Axios, { AxiosError } from 'axios';
import eventEmitter from '../utils/eventEmitter';

/**
 * Define a baseURL somente para a parte de autenticação
 */
function mountBaseUrlAuth() {
  const env = process.env.NODE_ENV;
  if (env === 'development') {
    return 'http://localhost:8000/api'; 
  }
  return 'https://connect.publisol.com.br/api';
}

// Cria a instância do Axios para AUTH
const authApi = Axios.create({
  baseURL: mountBaseUrlAuth(),
  withCredentials: true, // cookies de sessão
});

export { authApi };